import type {ProyectoFormDTO} from '../../../api/Objetos';

export function createEmptyProyecto(): ProyectoFormDTO {
    return {
        informacionGeneral: {},
        requerimientos: [],
        accionesSeguimiento: [],
        autorizacionesSolicitadas: [],
        datosContratos: {
            contratoMayores: [],
            contratoMenores: [],
            gastosImputadosFueraDeLaSubvencion: []
        },
        datosContables: {},
        seguimientoPlataforma: { datosVariables: { columns: ["1"], rows: [[""]], cellStyles: {} } },
        seguimientoCoFFE: { datosVariables: { columns: ["1"], rows: [[""]], cellStyles: {} } },
        certificacionesObra: { datosVariables: { columns: ["1"], rows: [[""]], cellStyles: {} } },
        hitosYObjetivos: [],
        participacionCiudadana: [],
        comunicacionProyecto: [],
        plazosEjecucionJustificacion: [],
        reuniones: [],
        informesGestion: []
    };
}
